var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("gmap-map", {
        ref: "gmap",
        staticStyle: { width: "100%" },
        attrs: { center: { lat: 10, lng: 10 }, zoom: 12, options: _vm.options }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }